<script lang="ts">
export default {
  name: "ChevronRightIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="h-3 w-3 md:h-5 md:w-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="2"
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
  </svg>
</template>
